import {Routes} from '@angular/router';
import {AuthRoutes} from './modules/authn/authn-routing';
import {AuthGuard} from '@core/guards/auth-guard';

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		canActivate: [AuthGuard],
		children: []
	},
	{
		path: 'go/external/:id',
		canActivate: [AuthGuard],
		loadComponent: () =>
			import('./core/components/external-menu-link-redirect/external-menu-link-redirect.component').then(
				(m) => m.ExternalMenuLinkRedirectComponent,
			),
	},
	{
		path: 'admin',
		canActivate: [AuthGuard],
		loadChildren: () => import('./modules/backoffice/backoffice.routes').then(m => m.backofficeRoutes),
	},
	{
		path: 'ventas',
		canActivate: [AuthGuard],
		loadChildren: () => import('./modules/frontoffice/frontoffice.routes').then(m => m.frontofficeRoutes),
	},
	...AuthRoutes,
	{
		path: '**',
		redirectTo: 'login'
	}
];
